import { apiService } from '..';
import { ToastSwal } from '../../components/components/general/toastSwals/toastSwal';
import {
    PostQuestionResponse,
    ToolTypeEnum,
} from '../../shared/types/assistant';
import { Attachment } from '../../shared/types/shared';

export const postQuestionUseCase = async (
    idChatAssistant: string,
    threadId: string,
    question: string,
    toolType: ToolTypeEnum,
    files: Attachment[],
    previousResponseId?: string
) => {
    try {
        const resp: any = await apiService.post(
            `/api/sam-assistant/user-question/${idChatAssistant}`,
            {
                threadId,
                question,
                toolType,
                attachments: files,
                ...(previousResponseId ? { previousResponseId } : {}),
            }
        );
        if (resp?.errors) {
            if (resp?.errors?.['[SAM_ASSISTANT] INVALID_FILE_TYPE']) {
                ToastSwal.fire({
                    text: 'Solo se permiten archivos .docx, .pptx, .xlsx, .pdf o .txt',
                    icon: 'error',
                    timer: 5000,
                    position: 'center-end',
                });
            } else {
                ToastSwal.fire({
                    text: 'Ocurrió un error, intenta de nuevo más tarde',
                    icon: 'error',
                    timer: 5000,
                    position: 'center-end',
                });
            }
        } else {
            const replies = resp as PostQuestionResponse;

            return replies;
        }
    } catch (error) {
        ToastSwal.fire({
            text: 'Ocurrió un error, intenta de nuevo más tarde',
            icon: 'error',
            timer: 5000,
            position: 'center-end',
        });
    }
};
